import { CorrelationGraph } from 'state/quotes/correlations/correlations.model';
import type { SelectedCorrelationGraphStateMap } from 'state/quotes/selectedCorrelationGraph/selectedCorrelationGraph.model';

export function getSelectedCorrelationGraph(
  state: SelectedCorrelationGraphStateMap,
  tabId: string | undefined,
): CorrelationGraph | undefined {
  return tabId ? state[tabId] : undefined;
}
